import { useQuery } from '@tanstack/react-query'
import { fetchCandidateFaction, factionKeys } from '@/services/factions'

export function useCandidateFaction(candidateId: string | undefined) {
  const factionQuery = useQuery({
    queryKey: factionKeys.byCandidate(candidateId!),
    queryFn: () => fetchCandidateFaction(candidateId!),
    enabled: !!candidateId,
  })

  return {
    faction: factionQuery.data,
    isLoading: factionQuery.isLoading,
    error: factionQuery.error,
  }
}
